// safe method to use with untrusted user input:  https://stackoverflow.com/a/1395954/15431300
export default function decodeHTMLEntities(encodedString) {
	const textArea = document.createElement('textarea');
	textArea.innerHTML = encodedString;
	return textArea.value;
}
